import styles from './Note.module.scss';

export function Note(props) {
  return (
    <div className={styles.note}>
      <blockquote>{props.children}</blockquote>
    </div>
  );
}
